import React from "react";
import { Link } from "react-router-dom";
import footerBg from "../../assets/img/bg/footer_two_bg.jpg";
import logo from "../../assets/img/logo/silverwave-logo.png";

export const FooterTwo = () => {
  return (
    <footer>
      <div
        className="footer-area-two footer-bg-two"
        style={{ backgroundImage: `url(${footerBg})` }}
      >
        <div className="footer-top-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <div className="fw-logo">
                    <Link to="/">
                      <img src={logo} alt="Silverwave logo" />
                    </Link>
                  </div>

                  <div className="footer-content">
                    <p>
                    Bookkeeping for startups and small businesses in 
                    Surrey, Delta, Langley and White Rock. Flat monthly pricing, books closed by the 15th.
                    </p>
                    <div className="footer-info">
                      <ul className="list-wrap">
                        <li>
                          <div className="icon">
                            <i className="flaticon-phone-call"></i>
                          </div>
                          <div className="content">
                            <a href="tel:0123456789">604-XXX-XXXX</a>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <i className="flaticon-clock"></i>
                          </div>
                          <div className="content">
                            <p>
                              Mon – Fri: 9 am – 5 pm, <br />
                              Weekends: <span>BY APPOINTMENT</span>
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Company</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/contact">Services</Link>
                      </li>
                      <li>
                        <Link to="/contact">Pricing</Link>
                      </li>
                      <li>
                        <Link to="/blog">Contact</Link>
                      </li>
                      <li>
                        <Link to="/contact">Privacy Policy</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Services</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/contact">Startup Bookkeeping</Link>
                      </li>
                      <li>
                        <Link to="/contact">Monthly Bookkeeping</Link>
                      </li>
                      <li>
                        <Link to="/contact">Catch-Up Bookkeeping</Link>
                      </li>
                      <li>
                        <Link to="/contact">Trucking Bookkeeping</Link>
                      </li>
                      <li>
                        <Link to="/contact">Construction Bookkeeping</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <h4 className="fw-title">Free Year-End Checklist</h4>
                  <div className="footer-newsletter">
                    <p>
                    Get our year-end bookkeeping checklist for Surrey businesses by email.
                    </p>
                    <form action="#">
                      <input type="email" placeholder="enter your e-mail" />
                      <button type="submit">Subscribe</button>
                    </form>
                    <div className="footer-social footer-social-two">
                      <ul className="list-wrap">
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-pinterest-p"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text-two text-center">
                  <p>Copyright © 2026 Silverwave Accounting & Bookkeeping, Surrey, BC. Bookkeeping services only.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
